import React from 'react'
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import { makeStyles, MenuItem } from '@material-ui/core';
import Container from '@material-ui/core/Container';
import Select from '@material-ui/core/Select';
import {Link} from 'react-router-dom';
import {createTheme} from '@material-ui/core';
import { ThemeProvider } from '@material-ui/core';

const useStyles = makeStyles((theme)=>({
  root: {
    flexGrow: 1,
  },
  title: {
    flexGrow: 1,
    color: "gold",
    fontWeight: "bold",
    cursor: "pointer"
  },
  selectTag: {
    width: 100,
    height: 40,
    marginLeft: 15
  }
}));

const darkTheme = createTheme({
  palette: {
    primary: {
     main: "#fff"
    },
    type: 'dark',
  },
});

const Header = () => {
  const classes = useStyles();
  return (
    <ThemeProvider theme={darkTheme}>
      <AppBar position="static" color="transparent">
        <Container>
        <Toolbar>
          <Typography variant="h6" className={classes.title}>
            <Link to="/">Crypto App</Link>
          </Typography>
          {/* <Select className={classes.selectTag} value={currency} onChange={(e)=>setcurrency(e.target.value)} variant="outlined">
              <MenuItem value={'USD'}>USD</MenuItem>
              <MenuItem value={'INR'}>INR</MenuItem>
          </Select> */}
        </Toolbar>
        </Container>
      </AppBar>
    </ThemeProvider>
  )
}

export default Header